export let ScrollAreaRootDataAttributes = /*#__PURE__*/function (ScrollAreaRootDataAttributes) {
  /**
   * Present when the user scrolls inside the scroll area.
   */
  ScrollAreaRootDataAttributes["scrolling"] = "data-scrolling";
  /**
   * Present when the scroll area content is wider than the viewport.
   */
  ScrollAreaRootDataAttributes["hasOverflowX"] = "data-has-overflow-x";
  /**
   * Present when the scroll area content is taller than the viewport.
   */
  ScrollAreaRootDataAttributes["hasOverflowY"] = "data-has-overflow-y";
  /**
   * Present when there is overflow on the horizontal start side.
   */
  ScrollAreaRootDataAttributes["overflowXStart"] = "data-overflow-x-start";
  /**
   * Present when there is overflow on the horizontal end side.
   */
  ScrollAreaRootDataAttributes["overflowXEnd"] = "data-overflow-x-end";
  /**
   * Present when there is overflow on the vertical start side.
   */
  ScrollAreaRootDataAttributes["overflowYStart"] = "data-overflow-y-start";
  /**
   * Present when there is overflow on the vertical end side.
   */
  ScrollAreaRootDataAttributes["overflowYEnd"] = "data-overflow-y-end";
  return ScrollAreaRootDataAttributes;
}({});